"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var DefaultLayout_1 = __importDefault(require("./components/DefaultLayout"));
var react_redux_1 = require("react-redux");
var react_intl_1 = require("react-intl");
var react_router_dom_1 = require("react-router-dom");
var NotFoundPage_1 = require("./views/NotFoundPage");
var configureStore_1 = __importDefault(require("./redux/store/configureStore"));
var zh_1 = __importDefault(require("./i18n/zh"));
var en_1 = __importDefault(require("./i18n/en"));
var useNavigatorLanguage_1 = __importStar(require("./use/useNavigatorLanguage"));
var core_1 = require("@material-ui/core");
var theme_1 = __importDefault(require("./assets/styles/theme"));
var ProductLayout_1 = __importDefault(require("./components/ProductLayout"));
var ContactLayout_1 = __importDefault(require("./components/ContactLayout"));
var AboutUSLayout_1 = __importDefault(require("./components/AboutUSLayout"));
var AppView = function () {
    var _a = useNavigatorLanguage_1.default(), locale = _a[0], setLocale = _a[1];
    console.log("locale : " + locale);
    var messages;
    if (locale.toLocaleLowerCase().includes('zh-tw'.toLocaleLowerCase())) {
        messages = zh_1.default;
    }
    else {
        messages = en_1.default;
    }
    return (react_1.default.createElement(useNavigatorLanguage_1.LocaleContext.Provider, { value: [locale, setLocale] },
        react_1.default.createElement(react_intl_1.IntlProvider, { locale: locale, key: locale, messages: messages },
            react_1.default.createElement(react_redux_1.Provider, { store: configureStore_1.default },
                react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                    react_1.default.createElement(core_1.ThemeProvider, { theme: theme_1.default },
                        react_1.default.createElement(core_1.CssBaseline, null),
                        react_1.default.createElement(DefaultLayout_1.default, null,
                            react_1.default.createElement(react_router_dom_1.Switch, null,
                                react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/", component: ProductLayout_1.default }),
                                react_1.default.createElement(react_router_dom_1.Route, { path: "/productcenter", component: ProductLayout_1.default }),
                                react_1.default.createElement(react_router_dom_1.Route, { path: "/contact", component: ContactLayout_1.default }),
                                react_1.default.createElement(react_router_dom_1.Route, { path: "/about", component: AboutUSLayout_1.default }),
                                react_1.default.createElement(react_router_dom_1.Route, { component: NotFoundPage_1.NotFoundPage })))))))));
};
react_dom_1.default.render(react_1.default.createElement(AppView, null), document.getElementById("root"));
